export default "__VITE_ASSET__$fYa6mwf__"